import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '../KeyComponents';

function DropdownLabel({ children, required, info }) {
  return (
    <Label required={required} info={info} label={children} />
  );
}

DropdownLabel.propTypes = {
  children: PropTypes.node,
  required: PropTypes.bool,
  info: PropTypes.string,
};

DropdownLabel.defaultProps = {
  children: null,
  required: false,
  info: '',
};

export default DropdownLabel;
